window.FormValidation = require("../../../../../core/plugins/formvalidation/dist/js/FormValidation.full.min");
window.FormValidationBootstrap5 = require("../../../../../core/plugins/formvalidation/dist/js/plugins/Bootstrap5");
require('./../../../../../core/js/scripts');
require('./../../../../../custom/js/scripts/api');

import Step1 from './Step1.js';
import Step2 from './Step2.js';
import Step3 from './Step3.js';
import StepType from "./StepType";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import Step7 from "./Step7";
import Step8 from "./Step8";
import Step9 from "./Step9";

class Register {
    constructor(authUser, chosen_plan, brand = 'retaildesk', initialStep = 1, registrationAllowed = true) {
        this._currentStep = initialStep;
        this.stepper = null;
        this.companyData = {};
        this.brand = brand;
        this.initialStep = initialStep;
        this.registrationAllowed = registrationAllowed;

        // Initialize steps
        this.steps = [
            new Step1(), // account
            new Step2(), // verification
            new Step3(), // company
            new StepType(), // business_type
            new Step4(), // plan
            new Step5(registrationAllowed), // congrats
            new Step6(), // loader
            new Step7(), // scheduler
            new Step8(), // confirm_demo
            new Step9(), // location
        ];

        // Create name-to-step mapping for easier access
        this.stepMap = {};
        this.steps.forEach(step => {
            this.stepMap[step.name] = step;
        });

        this.chosen_plan = chosen_plan;
        this.initUser(authUser);
    }

    /**
     * Get the current active step object
     */
    get currentStep() {
        return this.steps[this._currentStep - 1];
    }

    /**
     * Get a step object by its name
     * @param {string} name 
     */
    getStepByName(name) {
        return this.stepMap[name];
    }

    /**
     * Get a step index by its name (1-indexed)
     * @param {string} name 
     */
    getStepIndex(name) {
        const step = this.getStepByName(name);
        return step ? step.step : null;
    }

    init() {
        console.log('Register init');
        this.initStepper();

        // Listen for navigation events
        $(document).on('stepper:next', (e, target) => {
            console.log('Event stepper:next received', target);
            this.goNext(target);
        });

        $(document).on('stepper:previous', () => {
            console.log('Event stepper:previous received');
            this.goPrevious();
        });

        $(document).on('stepper:goto', (e, target) => {
            console.log('Event stepper:goto received', target);
            this.goToStep(target);
        });
    }

    /**
     * Navigate to a step by its name or ID
     * @param {string|number|null} target - Step name or ID. If null, goes to next step.
     */
    goNext(target = null) {
        let stepId = null;

        if (target === null) {
            stepId = this._currentStep + 1;
        } else if (typeof target === 'string') {
            stepId = this.getStepIndex(target);
            if (!stepId) {
                console.error(`Step with name "${target}" not found`);
                return;
            }
        } else {
            stepId = target;
        }

        console.log(`Navigating from step ${this._currentStep} to step: ${stepId} (${this.steps[stepId - 1].name})`);

        this._currentStep = stepId;

        // Update body class for CSS visibility logic
        this.updateStepVisibility();

        // Initialize the step
        if (this.currentStep) {
            this.currentStep.stepStarted();
            this.currentStep.init();
        }
    }

    /**
     * Alias for goNext to make it more intuitive when jumping
     */
    goToStep(target) {
        this.goNext(target);
    }

    goPrevious() {
        this._currentStep = this._currentStep - 1;

        // Update body classes
        this.updateStepVisibility();

        // Initialize the step
        if (this.currentStep) {
            this.currentStep.init();
        }
    }

    updateStepVisibility() {
        const stepperElement = document.querySelector('#register_stepper');
        if (!stepperElement) {
            console.error('#register_stepper not found in DOM');
            return;
        }

        // Clean up both body and stepper of all residual step-active classes
        const removeClasses = (el) => {
            if (!el) return;
            Array.from(el.classList).forEach(className => {
                if (className.startsWith('step-') && className.endsWith('-active')) {
                    el.classList.remove(className);
                }
            });
        };

        removeClasses(document.body);
        removeClasses(stepperElement);

        // Add ONLY the current step name class to the stepper element
        if (this.currentStep && this.currentStep.name) {
            const activeClass = `step-${this.currentStep.name}-active`;
            stepperElement.classList.add(activeClass);
            console.log(`Visibility updated: ${activeClass} added to #register_stepper`);
        } else {
            console.error('Current step or name not found in updateStepVisibility');
        }
    }

    async initStepper() {
        console.log('Initializing custom stepper');

        // Set current step
        this._currentStep = this.initialStep;

        // Update body classes
        this.updateStepVisibility();

        // Initialize current step
        if (this.currentStep) {
            this.currentStep.stepStarted();
            this.currentStep.init();
        }
    }

    async checkDemoAndNavigate() {
        try {
            const response = await API.get('/demo/existing');

            if (response.status === 'success' && response.demo) {
                console.log('User has existing demo, navigating to loader');
                this.goNext('loader');
            } else {
                console.log('No existing demo, navigating to congrats');
                this.goNext('congrats');
            }
        } catch (error) {
            console.error('Error checking existing demo:', error);
            this.goNext('congrats');
        }
    }

    updateStepperVisualState(stepNumber) {
        // Keep for compatibility but we mostly rely on KTStepper
    }

    initUser(authUser) {
        this.authUser = authUser;

        if (!this.authUser) {
            return;
        }

        $(`[data-field="user.firstname"]`).text(this.authUser.firstname);
    }
}

window.register = new Register(user, chosen_plan, brand, initialStep, registrationAllowed);
// init() is called in the Blade file on document ready
